import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquareIcon, PhoneIcon } from 'lucide-react';
import { business } from '../data/business';
import { copy } from '../data/copy';
import { useLanguage } from '../contexts/LanguageContext';
import type { L } from '../types/i18n';
interface CtaBandProps {
  title?: L;
  description?: L;
}
export function CtaBand({
  title,
  description
}: CtaBandProps) {
  const {
    t
  } = useLanguage();
  return <section className="bg-navy-900" data-id="element-131" data-mp="rf2x9fkkjzo0">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-6 py-14 lg:flex-row lg:items-center lg:justify-between" data-id="element-132" data-mp="vgoippb65m9t">
        <div className="max-w-xl" data-id="element-133" data-mp="107d7uxzdm75s">
          <h2 className="font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-134" data-mp="108exc7h52w71">
            {t(title ?? copy.ctaBand.title)}
          </h2>
          <p className="mt-3 text-navy-200" data-id="element-135" data-mp="1a62rowau21oo">
            {t(description ?? copy.ctaBand.description)}
          </p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row lg:shrink-0" data-id="element-136" data-mp="1f5yy1270657e">
          <Link to="/contact" className="flex min-h-[52px] items-center justify-center rounded-md bg-gold-500 px-7 font-bold text-navy-950 transition-colors duration-150 ease-smooth hover:bg-gold-400" data-id="element-137" data-mp="1z73mardf43vb">
            {t(copy.cta.book)}
          </Link>
          <a href={business.phoneHref} className="flex min-h-[52px] items-center justify-center gap-2 rounded-md border border-navy-600 px-7 font-bold text-white transition-colors duration-150 ease-smooth hover:bg-navy-800" data-id="element-138" data-mp="1l7lqvt5m9scz">
            <PhoneIcon width={18} height={18} aria-hidden="true" data-id="element-139" data-mp="2czbfk95htcp9" />
            {business.phoneDisplay}
          </a>
          <a href={business.whatsappHref} target="_blank" rel="noreferrer" className="flex min-h-[52px] items-center justify-center gap-2 rounded-md border border-navy-700 px-7 font-bold text-navy-100 transition-colors duration-150 ease-smooth hover:bg-navy-800" data-id="element-140" data-mp="285yqjxwwj3vz">
            <MessageSquareIcon width={18} height={18} aria-hidden="true" data-id="element-141" data-mp="u03ojnnqtjnd" />
            {t(copy.cta.whatsapp)}
          </a>
        </div>
      </div>
    </section>;
}